<template>
    <v-card-text>
        <v-row dense>
            <v-col cols="12" sm="12">
                <ModalConfirmacionCancelacionComponent :open="abrirModal" :obModal="obModal" :tipo="tipo"/>
            </v-col>
        </v-row>
        <v-row dense align="center" justify="center">
            <v-col cols="12" sm="4" v-for="(v,k) in listCertificados" :key="k">
                <v-tooltip right color="primary">
                    <template v-slot:activator="{ on }">
                        <v-img :src="v.foto" contain height="300px" max-height="300px" v-on="on"></v-img>
                    </template>
                    <span>
                        <table width="100%">
                            <tbody>
                                <tr>
                                    <td> <strong class="white--text body-2">Vigencia Desde: </strong> </td>
                                    <td class="body-2" v-html="v.fechaDesde"> </td>
                                <tr>
                                <tr>
                                    <td> <strong class="white--text body-2">Vigencia Hasta: </strong> </td>
                                    <td class="body-2" v-html="v.fechaHasta"> </td>
                                <tr>
                                <tr>
                                    <td> <strong class="white--text body-2">Cédula: </strong> </td>
                                    <td class="body-2" v-html="v.numeroDocumento"> </td>
                                <tr>
                                <tr>
                                    <td> <strong class="white--text body-2">Cliente: </strong> </td>
                                    <td class="body-2" v-html="v.nombreCliente"> </td>
                                <tr>
                                <tr>
                                    <td> <strong class="white--text body-2">Marca: </strong> </td>
                                    <td class="body-2" v-html="v.marca"> </td>
                                <tr>
                                    <td> <strong class="white--text body-2">Modelo: </strong> </td>
                                    <td class="body-2" v-html="v.modelo"> </td>
                                </tr>
                                <tr>
                                    <td> <strong class="white--text body-2">Año: </strong> </td>
                                    <td class="body-2" v-html="v.anio"> </td>
                                </tr>
                                <tr>
                                    <td> <strong class="white--text body-2">Valor Asegurado: </strong> </td>
                                    <td class="body-2" v-html="`$ ${v.valorVehiculo}`"> </td>
                                </tr>
                                <tr>
                                    <td> <strong class="white--text body-2">Prima: </strong> </td>
                                    <td class="body-2" v-html="`$ ${v.primaNeta}`"> </td>
                                </tr>
                            </tbody>
                        </table>
                    </span>
                </v-tooltip>
                <div class="text-center">
                    <h3 class="headline">Placa: {{ v.placa }}</h3>
                </div>
                <v-btn block rounded dark color="primary" @click="validar(v)">Cancelar Póliza</v-btn>
            </v-col>
        </v-row>
    </v-card-text>
</template>
<script>
    export default {
        name: 'StepperInformacionSeguroVehiculoComponent',
        components: {
            ModalConfirmacionCancelacionComponent: () => import('@/components/ajustePoliza/cancelacion/ModalConfirmacionCancelacionComponent.vue'),
            StepperFormaDevolucionComponent: () => import('./StepperFormaDevolucionComponent.vue')
        },
        inject: ['insertarCancelacion', 'setData', 'setStep'],
        props: {
            load: {
                type: Boolean,
                default: false
            },
            parametros: {
                type: Object,
                default: {}
            },
            listCertificados: {
                type: Array,
                default: []
            }
        },
        data: () => ({
            parametro: {},
            abrirModal:false,
            tipo:1,
            obModal:{},
            cambio:false
        }),
        methods: {
            onCargaGeneral(event) {
                if (!_.isUndefined(event)) {
                    var error = 'E';
                    var o = { idProducto: _.get(this.obModal, 'idProducto', null) };

                    axios.post(`${BASE_URI}administrador/cancelacion/vehiculo/cargaGeneralVehiculo`,o)
                         .then((r) => {
                            if(_.get(r,['data','existeError'], true)) throw mensajeEstandar.errorPeticion;
                            if(_.size(r,['data','data'], []) == 0) {error="I"; throw _.get(r, ['data', 'mensaje'],mensajeEstandar.errorPeticion);}
                                this.setData('listGeneral',r.data.data.listas);
                                this.setData('parametros',r.data.data.parametros);
                                this.setStep(3);
                                this.abrirModal = false;
                         })
                         .catch((e) => {
                             mensajesAlerta(e, error);
                         });
                }
            },
            validar(v){
                this.cambio = false;
                if(
                    (_.toNumber(v.idCertificado) != _.toNumber(_.get(this.obModal,'idCertificado',-1))) || 
                    (_.toNumber(v.idPoliza) != _.toNumber(_.get(this.obModal,'idPoliza',-1)))
                ){
                    this.$set(this,'obModal',v);
                    this.cambio = true;
                }
                    this.abrirModal = true;
            },
            cancelacion(v) {
                this.setData('obSearch',v);
                if(this.cambio)
                    this.onCargaGeneral('L');
                else{
                    this.abrirModal = false;
                    this.setStep(3);
                }
            },
            onClose(band=false){
                if(band){
                    this.abrirModal = false;
                    this.tipo = 1;
                    this.$set(this,'obModal',{});
                }else
                    this.tipo = 2;
            }
        },
        provide(){
            return{
                onClose:this.onClose,
                cancelacion:this.cancelacion
            }
        }
    }
</script>